module.exports = __webpack_public_path__ + "static/media/Project1_Fig10.b5450626.svg";